import React, { useRef } from 'react'

import { useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import Swal from 'sweetalert2'
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
// import './customer_style.css';
import Barcode from 'react-barcode';
import Modal from 'react-bootstrap/Modal';
// import { useLocation } from 'react-router-dom';
import ReactLoading from 'react-loading';
import config from "../../config"
import download from 'downloadjs'
import Moment from 'react-moment';
import TablePagination from '@mui/material/TablePagination';
import htmlToPdfmake from 'html-to-pdfmake';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import moment from 'moment';
import html2canvas from 'html2canvas';
// import BarcodeComponent from './BacodeComponent'
import { renderToString } from 'react-dom/server';
import createRoot from 'react-dom';
import { useNetworkState } from 'react-use';
import { BarcodeIcon, CornerUpLeft, DollarSign, FileDown, Package, PackageCheck, PackageIcon, PackageSearch, ShoppingBag, ShoppingBasket, Truck, TruckIcon } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import $ from 'jquery';
import 'daterangepicker/daterangepicker.css'; // Import daterangepicker CSS
import 'daterangepicker';


const Ndr = () => {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  let navigate = useNavigate()
  const isOnline = useNetworkState();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pendingOrder = searchParams.get('type');
  console.log("pendingOrder == " , pendingOrder)
  // console.log("isONline  === " ,isOnline )
  // const barcodeRef = useRef(null);
  let userDetail = localStorage.getItem('ship_rocket_user');
  // console.log("userDetail====shipments====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail)
  }
  const [openOffcanvasfilter, setOpenOffcanvasfilter] = React.useState(false);
  const [history, sethistory] = React.useState({ ndr_history: [], awb: "" })
  console.log("history == ", history)
  const [ndrmodal, setndrmodal] = React.useState(false)
  const [bulkndrmodal, setbulkndrmodal] = React.useState(false)
  const [bulkndrloader, setbulkndrloader] = React.useState(false)
  const [replyText, setReplyText] = React.useState(""); // Reply text
  const [viewModal, setviewModal] = React.useState({ show: false, sub: {} })
  const [ndrloader, setndrloader] = React.useState(false)

  const [loaderpickup, setloaderpickup] = React.useState(false)
  const [dimensionState, setdimensionState] = React.useState({ companyDetail: [] })
  const [state, setState] = React.useState({ shipment_list: [], isLoading: true, count_all: 0, count_action_required: 0, count_action_requested: 0, count_delivered: 0, count_rto: 0 })
  const [labelstate, setlabel] = React.useState({ shipment_list: [], isLoading: true })
  const [searchstate, setsearchstate] = React.useState({ search_shipment: "" })
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [shipmentstate, setshipStatus] = React.useState({ shipment_status: null });

  const [isLoading, setisLoading] = React.useState(true)

  // console.log("pickupstate ==== " , pickupstate)
  const [selectedShipments, setSelectedShipments] = React.useState([]);
  // console.log("selectedShipments === " ,selectedShipments)
  const [selectCount, setSelectCount] = React.useState({ select_count: 0 })
  const [addressState, setaddressState] = React.useState([]);

  const [otherStates, setOtherState] = React.useState({ dstatus: "", activePage: 1, rowsPerPage: 20, page: 0, total_count: 0, onload: true });
  // console.log("otherState ==== " , otherStates)


  const [selectedDateTime, setSelectedDateTime] = React.useState(null);
  const [selectedTime, setSelectedTime] = React.useState('9:00');
  const [cancelshipment, setcancelshipment] = React.useState(false)
  const [openOffdetailcanvas, setOpenOffdetailcanvas] = React.useState(false);
  const [bookorder, setbookorder] = React.useState([])
  console.log("bookorder == ", bookorder)

  const [date, setdate] = React.useState({ from_date: moment().subtract(30, 'days').format('YYYY-MM-DD'), to_date: moment().format('YYYY-MM-DD') })
  const [paymentmode, setpaymentmode] = React.useState({ cod: false, prepaid: false })
  const [warehouse, setwarehouse] = React.useState([])
  const [selectedWarehouses, setSelectedWarehouses] = React.useState([]);
  const [searchfilters, setsearchFilters] = React.useState({ searchtitle: "", filter: [{ name: "booked", value: 1, status: true }, { name: "assigned", value: 2, status: true }, { name: "intransit", value: 3, status: true }, { name: "delivered", value: 4, status: true }], filterStatus: [] })
  const [failedstate, setfailed] = React.useState({ failed: "" })
  const [trackingstate, setTrackingState] = React.useState({ track: {}, isLoading: true })
  const [stateship, setStateship] = React.useState({ shipmentDetail: { sender: {}, receiver: {}, items: [] }, isLoading: true, detailFound: false, parcel_count: 0 })
  const [showComponent, setShowComponent] = React.useState(true);
  const [stateshipment, setShipments] = React.useState({ shipment: {} });
  const [ndrstate, setndrstate] = React.useState({ ndr_date: "", ndr_address: "", ndr_phone: "", ndr_remarks: "" })

  const [typestate, setType] = React.useState({ type: 5 })
  const [showEditConsignee, setShowEditConsignee] = React.useState(false);
  const [selectedConsigneeField, setSelectedConsigneeField] = React.useState('');
  const [editedConsignee, setEditedConsignee] =React.useState({
    name: '',
    address: '',
    mobile: '',
    payment_mode: '',
    cod_amount: ''
  });
  const [isUpdatingConsignee, setIsUpdatingConsignee] = React.useState(false);



  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 5000
  })

  // console.log("shipmentState",shipmentstate)
  React.useEffect(() => {

    shipmentList(null, 0, true)
    dimension_detail()
  }, [])
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
      homeSection.classList.toggle('sidebar-closed');
    }
  };

  const shipment_tracking = (shipment_id) => {

    let full_api = config.apiUrl + `/shipment/shipment_tracking`;
    let sendData = { customer_id: userData.customer_id, trackingNumber: shipment_id };
    // console.log("sendData",sendData)

    axios.post(full_api, sendData, { headers: config.headers }).then(res => {
      if (res.data.status == 200) {
        setTrackingState({ ...trackingstate, track: res.data.output, isLoading: false })
        // console.log("res",trackingstate.track)
        setStateship({ ...stateship, shipmentDetail: res.data.ship_detail, isLoading: false })

      }
      else {
        setTrackingState({ ...trackingstate, track: res.data.output, isLoading: false })
        // console.log("res",trackingstate.track)
        setStateship({ ...stateship, shipmentDetail: res.data.ship_detail, isLoading: false })
      }


    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }
  const shipmentList = (status, index = 0, onLoad) => {
    setisLoading(true)
    console.log("status   ===", status)
    if (isOnline.online == true) {
      let dataToSend = {
        customer_id: userData.customer_id, find: searchstate.search_shipment, status: status, limit: otherStates.rowsPerPage, indexValue: index
      };
      if (date.from_date != "" && date.to_date != "") {
        dataToSend.from_date = date.from_date
        dataToSend.to_date = date.to_date

      }
      if(pendingOrder!=null){
        dataToSend.jp_read_unread=0 
      }
      if (selectedWarehouses.length > 0) {
        dataToSend.warehouse = selectedWarehouses
      }
      if (paymentmode.cod && !paymentmode.prepaid) {
        dataToSend.payment_mode = 'cod';
      } else if (!paymentmode.cod && paymentmode.prepaid) {
        dataToSend.payment_mode = 'prepaid';
      } else if (paymentmode.cod && paymentmode.prepaid) {
        dataToSend.payment_mode = 'both';
      }

      if (searchfilters.filterStatus.length > 0) {
        dataToSend.status = searchfilters.filterStatus
      }
      // console.log("datatoSend",dataToSend)
      let url = config.apiUrl + '/shipment/customer_shipments_ndr';

      // console.log("headers =========> ", config.headers);


      axios.post(url, dataToSend, { headers: config.headers })
        // // console.log("headers ====== " , config.headers)
        .then((res) => {
          // console.log("responseJson => ", res);

          if (onLoad) {
            setOtherState({ ...otherStates, total_count: res.data.count, page: index })

          }
          setState({ shipment_list: res.data.output, count_all: res.data.count_all, count_action_required: res.data.count_action_required, count_action_requested: res.data.count_action_requested, count_delivered: res.data.count_delivered, count_rto: res.data.count_rto, isLoading: false })
          setisLoading(false)

        })
        .catch((error) => {
          setisLoading(false)
          //Hide Loader
          //   setLoadingstate({...loadingstate,loading:false})
          // console.log(error);
        });
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: "Network Connection Error",

      })
      setisLoading(false)
    }

  }






  const dimension_detail = () => {
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};

    axios.post(full_api, sendData, { headers: config.headers }).then(res => {
      setdimensionState({ ...dimensionState, companyDetail: res.data.companyDetail });
      // console.log("rnmmmmm", res);
    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }



  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const filteredShipments = state.shipment_list
        .filter((shipment) => shipment.ndr_action_required === 0) // Filter shipments with ndr_action_required = 0
        .map((shipment) => shipment.shipment_id); // Map to shipment_id

      setSelectedShipments(filteredShipments);
      setSelectCount({ select_count: filteredShipments.length });
    } else {
      setSelectedShipments([]);
      setSelectCount({ select_count: 0 })

    }
  };

  const handleSelectAllmobile = () => {
    const isAllSelected = selectedShipments.length === state.shipment_list.length;
    const selectedIds = isAllSelected ? [] : state.shipment_list.map(order => order.shipment_id);

    setSelectedShipments({

      selectedIds,
    });
    setSelectCount({ select_count: selectedIds.length })

  };
  // const handleSelectIndividual = (event, shipmentId) => {
  //   if (event.target.checked) {
  //     setSelectedShipments([...selectedShipments, shipmentId]);
  //     setSelectCount({...selectCount , select_count :selectCount.select_count +1})
  //   } else {
  //     setSelectedShipments(selectedShipments.filter((id) => id !== shipmentId));
  //     setSelectCount({...selectCount , select_count :selectCount.select_count -1})
  //   }
  // };
  const handleSelectIndividual = (event, shipmentId, ndrActionRequired) => {
    if (ndrActionRequired !== 0) return; // Prevent selection if ndr_action_required is not 0

    if (event.target.checked) {
      setSelectedShipments([...selectedShipments, shipmentId]);
      setSelectCount({ ...selectCount, select_count: selectCount.select_count + 1 });
    } else {
      setSelectedShipments(selectedShipments.filter((id) => id !== shipmentId));
      setSelectCount({ ...selectCount, select_count: selectCount.select_count - 1 });
    }
  };



  const handlesearchShipment = (e) => {
    setsearchstate({ search_shipment: e.target.value })
  }


  const dateselect = (e) => {
    setdate({ ...date, [e.target.name]: moment(e.target.value).format('YYYY-MM-DD') })
  }



  const openModal = (sub) => {
    setndrmodal(true)
    setShipments({ shipment: sub })
  }
  const closemodal = (e) => {
    setndrmodal(false)
    setType({ ...typestate, type: 5 })
    setndrstate({ ...ndrstate, ndr_date: "", ndr_address: "", ndr_phone: "", ndr_remarks: "" })
    setShipments({ shipment: {} })
  }

  const bulkopenModal = (sub) => {
    setbulkndrmodal(true)
    setSelectedShipments(sub)
  }
  const bulkclosemodal = (e) => {
    setbulkndrmodal(false)
    setType({ ...typestate, type: 5 })
    setndrstate({ ...ndrstate, ndr_date: "", ndr_address: "", ndr_phone: "", ndr_remarks: "" })
    setSelectedShipments([])
  }

  const handleNDRchange = (e) => {
    setType({ ...typestate, type: e.target.value })
  }

  const handleNDRchnage = (e) => {
    setndrstate({ ...ndrstate, [e.target.name]: e.target.value })
  }

  const ndrReAttempt = () => {
    setndrloader(true)
    if (
      (typestate.type == 1 && ndrstate.ndr_date != "" && ndrstate.ndr_phone != "" && ndrstate.remarks != "") ||
      (typestate.type == 2 && ndrstate.ndr_date != "" && ndrstate.ndr_address != "" && ndrstate.remarks != "") ||
      (typestate.type == 0 && ndrstate.ndr_date != "" && ndrstate.remarks != "") ||
      (typestate.type == 3 && ndrstate.remarks != "")
    ) {
      let full_api = config.apiUrl + `/shipment/ndr_re_attempt`;
      let sendData = { type: typestate.type, shipment: stateshipment.shipment, ndrstate };
      console.log("sendData", sendData)

      axios.post(full_api, sendData, { headers: config.headers }).then(res => {
        if (res.data.status == true) {
          shipmentList(shipmentstate.shipment_status, otherStates.page, true)
          setndrmodal(false)
          setType({ ...typestate, type: 5 })
          setndrstate({ ...ndrstate, ndr_date: "", ndr_address: "", ndr_phone: "", ndr_remarks: "" })
          setShipments({ shipment: {} })
          setndrloader(false)

          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })

          Toast.fire({
            background: "#3659cd",
            type: 'success',
            title: res.data.message,
            color: "white"
          });
        }
        else {
          setndrmodal(false)
          setType({ ...typestate, type: 5 })
          setndrstate({ ...ndrstate, ndr_date: "", ndr_address: "", ndr_phone: "", ndr_remarks: "" })
          setShipments({ shipment: {} })
          setndrloader(false)

          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })

          Toast.fire({
            background: "#c2200a",
            type: 'unsuccess',
            title: res.data.message,
            color: "white"
          });
        }


      }).catch((e) => {
        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })

        Toast.fire({
          background: "#c2200a",
          type: 'unsuccess',
          title: "Something Went Wrong ",
          color: "white"
        });
        setndrloader(false)

        // toast.configure()
        //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      })
    } else {
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })

      Toast.fire({
        background: "#c2200a",
        type: 'unsuccess',
        title: "Please fill all the details ",
        color: "white"
      });
      setndrloader(false)

    }
  }


  const bulkndrReAttempt = () => {
    setbulkndrloader(true)
    if (
      (typestate.type == 1 && ndrstate.ndr_date != "" && ndrstate.ndr_phone != "" && ndrstate.remarks != "") ||
      (typestate.type == 2 && ndrstate.ndr_date != "" && ndrstate.ndr_address != "" && ndrstate.remarks != "") ||
      (typestate.type == 0 && ndrstate.ndr_date != "" && ndrstate.remarks != "") ||
      (typestate.type == 3 && ndrstate.remarks != "")
    ) {
      let full_api = config.apiUrl + `/shipment/bulk_ndr_re_attempt`;
      let sendData = { type: typestate.type, shipment: selectedShipments, ndrstate };
      console.log("sendData", sendData)

      axios.post(full_api, sendData, { headers: config.headers }).then(res => {
        if (res.data.status == true) {
          shipmentList(shipmentstate.shipment_status, otherStates.page, true)
          setbulkndrmodal(false)
          setType({ ...typestate, type: 5 })
          setndrstate({ ...ndrstate, ndr_date: "", ndr_address: "", ndr_phone: "", ndr_remarks: "" })
          setSelectedShipments([])
          setbulkndrloader(false)
          const allMessages = res.data.message.map((shipmentMessage) => {
            return `${shipmentMessage.message}`;
          }).join('\n');
          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 10000
          })

          Toast.fire({
            background: "#3659cd",
            type: 'success',
            width: '600px',
            title: allMessages,
            color: "white",
          });
        }
        else {
          setbulkndrmodal(false)
          setType({ ...typestate, type: 5 })
          setndrstate({ ...ndrstate, ndr_date: "", ndr_address: "", ndr_phone: "", ndr_remarks: "" })
          setSelectedShipments([])
          setbulkndrloader(false)
          const allMessages = res.data.message.map((shipmentMessage) => {
            return `${shipmentMessage.message}`;
          }).join('\n');
          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 10000
          })

          Toast.fire({
            background: "#c2200a",
            type: 'unsuccess',
            title: allMessages,
            color: "white",
            width: '600px',

          });
        }


      }).catch((e) => {
        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })

        Toast.fire({
          background: "#c2200a",
          type: 'unsuccess',
          title: "Something Went Wrong ",
          color: "white"
        });
        setbulkndrloader(false)

        // toast.configure()
        //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      })
    } else {
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })

      Toast.fire({
        background: "#c2200a",
        type: 'unsuccess',
        title: "Please fill all the details ",
        color: "white"
      });
      setbulkndrloader(false)

    }
  }

  const handlePageChange = (event, newPage) => {
    setOtherState({ ...otherStates, page: newPage })
    // console.log("newPage ", newPage);
    // getCountryList(newPage);
    shipmentList(shipmentstate.shipment_status, newPage, true)
  }
  const handleChangeRowsPerPage = (event, newPage) => {
    // console.log("event ", event.target.value);
    setOtherState({ ...otherStates, rowsPerPage: event.target.value })

  }
  React.useEffect(() => {
    shipmentList(shipmentstate.shipment_status, otherStates.page, true)
  }, [otherStates.rowsPerPage])


  const shipmentFilter = (status) => {
    // console.log("action ", status);
    setshipStatus({ ...shipmentstate, status: status })
    shipmentList(status, 0, true)
  }




  // Handle reply submission
  const handleReplySubmit = async () => {

    try {
      let full_api = config.apiUrl + `/shipment/update_jp_array`;
      let sendData = { shipment_id: viewModal.sub.shipment_id, reply: replyText };
      console.log("sendData", sendData)

      axios.post(full_api, sendData, { headers: config.headers }).then(response => {

        if (response.data.status == true) {
          Swal.fire({
            icon: 'success',
            title: 'Success...',
            text: "JP Action updated successfully!",
          });
          setReplyText("");
          setviewModal({ show: false, sub: {} })
          shipmentList(shipmentstate.shipment_status, otherStates.page, true)
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: "Failed to update jp action . Please try again.",
          });
        }
      })
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: "An error occurred. Please try again.",
      });
    }
  };



  const closemodaljp = () => {
    setviewModal({ show: false, sub: {} })
    setReplyText("");
  }

  const set_update = (sub) => {
    setviewModal({ show: true, sub: sub })
    update_jp(sub.shipment_id)

  }

  const update_jp = (shipment_id) => {
    try {
      let full_api = config.apiUrl + `/shipment/update_jp_read_unread`;
      let sendData = { shipment_id: shipment_id };
      console.log("sendData", sendData)

      axios.post(full_api, sendData, { headers: config.headers }).then(response => {
      })
    } catch (error) {

    }
  }
  const openOffdetailcanvasHandler = (sub) => {
    setOpenOffdetailcanvas(true);
    setbookorder(sub)
    shipment_tracking(sub.shipment_id)

  };
  const closeOffdetailcanvasHandler = () => {
    setOpenOffdetailcanvas(false);
    setbookorder([])
    setTrackingState({ track: {}, isLoading: true })
    setStateship({ shipmentDetail: { sender: {}, receiver: {}, items: [] }, isLoading: true, detailFound: false, parcel_count: 0 })

  };
  const copyAWBToClipboard = (item) => {
    navigator.clipboard.writeText(item).then(() => {

      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
      Toast.fire({
        background: "#3659cd",
        type: 'success',
        title: "AWB number copied to clipboard!",
        color: "white"
      });
    }).catch((err) => {
      console.error("Failed to copy text: ", err);
    });
  };
  const copyToClipboard = (item) => {
    navigator.clipboard.writeText(item).then(() => {

      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })
      Toast.fire({
        background: "#3659cd",
        type: 'success',
        title: "Order number copied to clipboard!",
        color: "white"
      });
    }).catch((err) => {
      console.error("Failed to copy text: ", err);
    });
  };
  const downloadDocket = async (sub) => {
    try {
      let url = config.apiUrl + '/shipment/download_docket';
      let dataToSend = {
        carrier_id: sub.carrier_id,
        lrnum: sub.lrnum,
      };

      const response = await axios.post(url, dataToSend, {
        headers: config.headers,
        responseType: 'blob', // <-- This is important
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `Docket_${sub.lrnum}.pdf`;
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error("Download error:", err);
      alert("Failed to download docket");

    }
  };

  const downloadPOD = async (sub) => {
    try {
      let url = config.apiUrl + '/shipment/download_pod';
      let dataToSend = {
        carrier_id: sub.carrier_id,
        lrnum: sub.lrnum,
      };

      const response = await axios.post(url, dataToSend, {
        headers: config.headers,
      });


      if (response.data.status == true) {

        const imageUrl = response.data.output; // full signed URL
        const link = document.createElement("a");
        link.href = imageUrl;
        link.setAttribute("download", "pod.jpg"); // name of file
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      else {
        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })

        Toast.fire({
          background: "#a61c09",
          type: 'unsuccess',
          title: "Failed to download POD ",
          color: "white"
        });
      }
    } catch (err) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })

      Toast.fire({
        background: "#a61c09",
        type: 'unsuccess',
        title: "Failed to download POD ",
        color: "white"
      });
    }

  };

  React.useEffect(() => {
    if (viewModal.show && viewModal.sub.receiver) {
      setEditedConsignee({
        name: viewModal.sub.receiver[0].name,
        address: viewModal.sub.receiver[0].address,
        mobile: viewModal.sub.receiver[0].mobile,
        payment_mode: viewModal.sub.payment_mode || '',
        cod_amount: viewModal.sub.cod_amount || ''
      });
    }
  }, [viewModal.show, viewModal.sub.receiver]);

  const handleConsigneeUpdate = async () => {
    if (!selectedConsigneeField || !editedConsignee[selectedConsigneeField]) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please select a field and enter a value',
      });
      return;
    }
  
    let actualPaymentMode = editedConsignee.payment_mode;
    let requiresCodAmount = false;

    if (selectedConsigneeField === 'payment_mode' && editedConsignee.payment_mode === 'prepaid') {
      actualPaymentMode = 'cod';
      requiresCodAmount = true;
    }
    else if(selectedConsigneeField === 'payment_mode' && editedConsignee.payment_mode === 'cod'){
      actualPaymentMode = 'prepaid';
      requiresCodAmount = false;
    }

    if (requiresCodAmount && !editedConsignee.cod_amount) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please enter COD amount when selecting COD payment mode',
      });
      return;
    }
    
    setIsUpdatingConsignee(true);

    try {
      const payload = {
        shipment: viewModal.sub,
        field: selectedConsigneeField,
        value: selectedConsigneeField === 'payment_mode' ? actualPaymentMode : editedConsignee[selectedConsigneeField]
      };
      
      if (selectedConsigneeField === 'payment_mode') {
        payload = {
          ...payload,
          payment_mode: actualPaymentMode,
          cod_amount: actualPaymentMode === 'cod' ? editedConsignee.cod_amount : null,
        };
      }

      const response = await axios.post(
        config.apiUrl +'/shipment/update_consignee', payload, { headers: config.headers });
      console.log("response ==", response)
      if (response.data.success) {
        // Update local state
        const updatedSub = {
          ...viewModal.sub,
          receiver: [{
            ...viewModal.sub.receiver[0],
            [selectedConsigneeField]: selectedConsigneeField === 'payment_mode' ? actualPaymentMode : editedConsignee[selectedConsigneeField]
          }],
          payment_mode: actualPaymentMode,
          cod_amount: actualPaymentMode === 'cod' ? editedConsignee.cod_amount : null,
        };

        setviewModal({ ...viewModal, sub: updatedSub });
        setSelectedConsigneeField('');
        setShowEditConsignee(false);
        // toast.success("Consignee details updated successfully!");
        Swal.fire({
          icon: 'success',
          title: 'Good job...',
          text: 'Consignee details updated successfully!',

        })
      } else {
        // toast.error(response.data.message || "Failed to update consignee details");
        Swal.fire({
          icon: 'error',
          title: 'Oops..',
          text: response.data.message || "Failed to update consignee details",

        })
      }
    } catch (error) {
      console.error("Error updating consignee:", error);
      Swal.fire({
        icon: 'error',
        title: 'Oops..',
        text: "An error occurred while updating consignee details",

      })
      // toast.error("An error occurred while updating consignee details");
    } finally {
      setIsUpdatingConsignee(false);
    }
  };
  return (
    <div>
      <Header />
      <div class="page-wrapper pinned">
        <div class="main-container">
          <div className='app-container'>
            <div class="app-body">


              <div class="container-fluid">

                <div class="mob_nav">
                  <div class=" d-flex justify-content-start ">
                    <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
                    <h2>NDR</h2>
                  </div>
                </div>



                <div class="row justify-content-between">
                  <div class="col-12 col-md-4 desk_nav">
                    <div class="d-flex">
                      <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
                      <h2>NDR</h2>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 mb-3">
                  </div>
                </div>



                <Modal show={ndrmodal} onHide={() => closemodal()} size='lg'>
                  <Modal.Header closeButton>
                    <Modal.Title> <h4 class="modal-title">NDR Submit Form</h4></Modal.Title>
                  </Modal.Header>
                  <Modal.Body >

                    <div class="modal-body">
                      <div class="row booking_info_bx">

                        <div className='row'>
                          <div className='col-12'>
                            <select className='form-select' onChange={(e) => handleNDRchange(e)}>
                              <option>Choose Action</option>
                              <option value="0">Re-Attempt</option>
                              {/* <option value="0">RTO</option> */}
                              {/* <option value="2">Update Address</option>
                                <option value="1">Update Phone</option> */}
                            </select>
                          </div>

                          <div className='row mt-2'>
                            {typestate.type == 1 ? <>
                              <div className='col-6 '>
                                <input className='form-control' placeholder='Enter phone' type='date' name="ndr_date" onChange={(e) => handleNDRchnage(e)}></input>
                              </div>
                              <div className='col-6 '>
                                <input className='form-control' placeholder='Enter phone' type='number' name="ndr_phone" onChange={(e) => handleNDRchnage(e)}></input>
                              </div>
                              <div className='col-12 m-2'>
                                <input className='form-control' placeholder='Enter Remarks' type='text' name="ndr_remarks" onChange={(e) => handleNDRchnage(e)}></input>
                              </div>
                            </>
                              : typestate.type == 2 ? <>
                                <div className='col-6 '>
                                  <input className='form-control' placeholder='Enter phone' type='date' name="ndr_date" onChange={(e) => handleNDRchnage(e)}></input>
                                </div>
                                <div className='col-6 '>
                                  <input className='form-control' placeholder='Enter address' type='text' name="ndr_address" onChange={(e) => handleNDRchnage(e)}></input>
                                </div>
                                <div className='col-12 mt-2'>
                                  <input className='form-control' placeholder='Enter Remarks' type='text' name="ndr_remarks" onChange={(e) => handleNDRchnage(e)}></input>
                                </div>
                              </>

                                : typestate.type == 0 ? <>
                                  <div className='col-12 '>
                                    <input className='form-control' placeholder='Enter phone' type='date' name="ndr_date" onChange={(e) => handleNDRchnage(e)}></input>
                                  </div>
                                  {/* <div className='col-6 '>
                                <input className='form-control' placeholder='Enter address' type='text'></input>
                              </div> */}
                                  <div className='col-12 mt-2'>
                                    <input className='form-control' placeholder='Enter Remarks' type='text' name="ndr_remarks" onChange={(e) => handleNDRchnage(e)}></input>
                                  </div>
                                </>
                                  : typestate.type == 3 ? <>
                                    <div className='col-12 mt-2'>
                                      <input className='form-control' placeholder='Enter Remarks' type='text' name="ndr_remarks" onChange={(e) => handleNDRchnage(e)}></input>
                                    </div>
                                  </>
                                    :
                                    ""}
                          </div>



                        </div>

                      </div>
                    </div>
                    <div class="modal-footer text-start">
                      {ndrloader == true ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} /></div>
                        : <>
                          <button type="button" class="btn btn-primary" onClick={() => ndrReAttempt()}>Submit</button>
                          <button type="button" class="btn btn-outline-danger" onClick={() => closemodal()}>I'll Do this later</button></>}
                    </div>


                  </Modal.Body>

                </Modal>



                <Modal show={bulkndrmodal} onHide={() => bulkclosemodal()} size='lg'>
                  <Modal.Header closeButton>
                    <Modal.Title> <h4 class="modal-title">Bulk NDR Submit Form</h4></Modal.Title>
                  </Modal.Header>
                  <Modal.Body >

                    <div class="modal-body">
                      <div class="row booking_info_bx">

                        <div className='row'>
                          <div className='col-12'>
                            <select className='form-select' onChange={(e) => handleNDRchange(e)}>
                              <option>Choose Action</option>
                              <option value="0">Re-Attempt</option>
                              {/* <option value="0">RTO</option> */}
                              {/* <option value="2">Update Address</option>
                                <option value="1">Update Phone</option> */}
                            </select>
                          </div>

                          <div className='row mt-2'>
                            {typestate.type == 1 ? <>
                              <div className='col-6 '>
                                <input className='form-control' placeholder='Enter phone' type='date' name="ndr_date" onChange={(e) => handleNDRchnage(e)}></input>
                              </div>
                              <div className='col-6 '>
                                <input className='form-control' placeholder='Enter phone' type='number' name="ndr_phone" onChange={(e) => handleNDRchnage(e)}></input>
                              </div>
                              <div className='col-12 m-2'>
                                <input className='form-control' placeholder='Enter Remarks' type='text' name="ndr_remarks" onChange={(e) => handleNDRchnage(e)}></input>
                              </div>
                            </>
                              : typestate.type == 2 ? <>
                                <div className='col-6 '>
                                  <input className='form-control' placeholder='Enter phone' type='date' name="ndr_date" onChange={(e) => handleNDRchnage(e)}></input>
                                </div>
                                <div className='col-6 '>
                                  <input className='form-control' placeholder='Enter address' type='text' name="ndr_address" onChange={(e) => handleNDRchnage(e)}></input>
                                </div>
                                <div className='col-12 mt-2'>
                                  <input className='form-control' placeholder='Enter Remarks' type='text' name="ndr_remarks" onChange={(e) => handleNDRchnage(e)}></input>
                                </div>
                              </>

                                : typestate.type == 0 ? <>
                                  <div className='col-12 '>
                                    <input className='form-control' placeholder='Enter phone' type='date' name="ndr_date" onChange={(e) => handleNDRchnage(e)}></input>
                                  </div>
                                  {/* <div className='col-6 '>
                                <input className='form-control' placeholder='Enter address' type='text'></input>
                              </div> */}
                                  <div className='col-12 mt-2'>
                                    <input className='form-control' placeholder='Enter Remarks' type='text' name="ndr_remarks" onChange={(e) => handleNDRchnage(e)}></input>
                                  </div>
                                </>
                                  : typestate.type == 3 ? <>
                                    <div className='col-12 mt-2'>
                                      <input className='form-control' placeholder='Enter Remarks' type='text' name="ndr_remarks" onChange={(e) => handleNDRchnage(e)}></input>
                                    </div>
                                  </>
                                    :
                                    ""}
                          </div>



                        </div>

                      </div>
                    </div>
                    <div class="modal-footer text-start">
                      {bulkndrloader == true ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} /></div>
                        : <>
                          <button type="button" class="btn btn-primary" onClick={() => bulkndrReAttempt()}>Submit</button>
                          <button type="button" class="btn btn-outline-danger" onClick={() => bulkclosemodal()}>I'll Do this later</button></>}
                    </div>


                  </Modal.Body>

                </Modal>


                <div class="card mb-3">
                  <div class="card-body">
                    <div class="row justify-content-between">
                      <div class="col-12 col-md-6 mb-1">
                        <div class="row g-1">
                          <div class="col-12 col-md-6">
                            <div class="input-group">
                              <input type="date" class="form-control" name='from_date' onChange={(e) => dateselect(e)} value={date.from_date} />
                              <input type="date" class="form-control" name='to_date' onChange={(e) => dateselect(e)} value={date.to_date} />

                              <span class="input-group-text">
                                <i class="bi bi-search" onClick={(e) => shipmentList(null, otherStates.page, true)}></i>
                              </span>
                            </div>
                          </div>
                          {/* <div class="col-12 col-md-6">
                <div class="search-box">
                    <div class="search-icon">
                    <i class="bi bi-search"></i>
                    </div>
                    <input type="text" class="search-input" placeholder="Search packages..."  onClick={(e)=>shipmentList(null,0,true)}/>
                </div>
              </div> */}
                        </div>
                      </div>
                      <div class="col-12 col-md-6 mb-1">
                        <div class="row justify-content-between">

                          <div class="col-6 col-md-3">
                            {selectCount.select_count == 0 ? "" :
                              <div class="dropdown">
                                <button type="button" class="btn btn-outline-secondary btn-sm dropdown-toggle" data-bs-toggle="dropdown" onClick={(e) => bulkopenModal(selectedShipments)} >
                                  Bulk Take Actions
                                </button>
                                {/* <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#">Re-Attempt</a></li>
                    <li><a class="dropdown-item" href="#">Update Address</a></li>
                    <li><a class="dropdown-item" href="#">Update Phone Number</a></li>
                    <li><a class="dropdown-item text-danger" href="#">Retrun</a></li>
                  </ul> */}
                              </div>
                            }
                          </div>
                          <div class="input-group input-group-sm mb-3">
                            {/* <select class="form-select">
                                    <option>AWB</option>
                                    <option>Order ID</option>
                                    <option>Phone Number</option>
                                </select> */}

                            <input type="text" class="form-control w-50" name="search_shipment" placeholder="Enter Tracking Number" onChange={(e) => handlesearchShipment(e)} value={searchstate.search_shipment} onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                shipmentList(null, otherStates.page, true);
                              }
                            }} />
                            <button class="btn btn-outline-primary" onClick={(e) => shipmentList(null, otherStates.page, true)}>Search</button>
                          </div>
                          {/* <div class="col-6 col-md-6 text-end">
                <a href="" class="btn btn-outline-secondary btn-block"  data-bs-toggle="offcanvas" data-bs-target="#NDR_Filter"><i class="bi bi-filter"></i> Filter</a>
              </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>




                <section class="ndr_bx">
                  <ul class="nav nav-pills mb-2">
                    <li class="nav-item">
                      <a class={(shipmentstate.status == null) ? 'nav-link active' : 'nav-link'} onClick={() => shipmentFilter(null)} style={{ cursor: "pointer" }}>All ({state.count_all})</a>
                    </li>
                    <li class="nav-item">
                      <a class={(shipmentstate.status == 0) ? 'nav-link active' : 'nav-link'} onClick={() => shipmentFilter(0)} style={{ cursor: "pointer" }}>Action Required ({state.count_action_required})</a>
                    </li>
                    <li class="nav-item">
                      <a class={(shipmentstate.status == 1) ? 'nav-link active' : 'nav-link'} onClick={() => shipmentFilter(1)} style={{ cursor: "pointer" }}>Action Requested ({state.count_action_requested})</a>
                    </li>
                    <li class="nav-item">
                      <a class={(shipmentstate.status == 2) ? 'nav-link active' : 'nav-link'} onClick={() => shipmentFilter(2)} style={{ cursor: "pointer" }}>Delivered ({state.count_delivered})</a>
                    </li>
                    <li class="nav-item">
                      <a class={(shipmentstate.status == 3) ? 'nav-link active' : 'nav-link'} onClick={() => shipmentFilter(3)} style={{ cursor: "pointer" }}>RTO ({state.count_rto})</a>
                    </li>
                  </ul>

                  <div class="tab-content">
                    <div class="tab-pane  active" id="home">
                      <div class="card data_table mb-3">
                        <div class="card-body">
                          {isLoading ? <div style={{ display: 'flex', justifyContent: 'center', marginLeft: "60px", alignItems: 'center', marginTop: "-200px", height: '100vh' }}>
                            <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} /></div> :
                            <div class="table-responsive">
                              <div class=" rounded-3">
                                <table class="table align-top table-striped table-hover m-0 table-xl">
                                  <thead>
                                    <tr>
                                      <th><input class="form-check-input form-check-input-lg" type="checkbox" onChange={handleSelectAll} /></th>
                                      {/* <th>Channel</th> */}
                                      {/* <th>NDR Date</th> */}
                                      <th>Order</th>
                                      {/* <th>Product Details</th> */}
                                      <th>Payment</th>
                                      <th>Customer</th>
                                      <th>Carrier</th>
                                      <th>Status</th>
                                      <th>Exception</th>
                                      <th>Last Action</th>
                                      <th>Actions</th>
                                      <th>JP Action</th>

                                    </tr>
                                  </thead>
                                  <tbody>
                                    {state.shipment_list.map((sub) => (
                                      <tr>
                                        <td><input class="form-check-input form-check-input-lg" type="checkbox" onClick={(e) => handleSelectIndividual(e, sub.shipment_id, sub.ndr_action_required)}
                                          checked={selectedShipments.includes(sub.shipment_id)}
                                          disabled={sub.ndr_action_required !== 0} /></td>
                                        {/* <td>
                                          <a href="" data-bs-toggle="tooltip" title="Direct Sales">Direct Sales</a>
                                        </td> */}
                                        {/* <td>
                      <div><small>Dec 9, 2:28PM</small></div>
                    </td> */}
                                        <td>
                                          {sub.carrier_type == "B2B" ? <h6><a onClick={() => openOffdetailcanvasHandler(sub)} style={{ cursor: "pointer" }} class="text-primary" >LR {sub.lrnum != undefined && sub.lrnum != "" ? sub.lrnum : ""}</a> <a onClick={(e) => copyAWBToClipboard(sub.lrnum)} data-bs-toggle="tooltip" title="Copy LR Number"><i class="bi bi-c-square"></i></a> </h6> :

                                            <h6><a onClick={() => openOffdetailcanvasHandler(sub)} style={{ cursor: "pointer" }} class="text-primary" >AWB {sub.carrier_tracking_number != undefined && sub.carrier_tracking_number != "" ? sub.carrier_tracking_number : ""}</a> <a onClick={(e) => copyAWBToClipboard(sub.carrier_tracking_number)} data-bs-toggle="tooltip" title="Copy AWB Number"><i class="bi bi-c-square"></i></a> </h6>}
                                          <div><small>Order ID: {sub.order_number} <a onClick={(e) => copyToClipboard(sub.order_number)} data-bs-toggle="tooltip" title="Copy Order Number"><i class="bi bi-c-square"></i></a></small></div>
                                          <div><small><Moment format="MMM DD YYYY">
                                            {new Date(sub.created * 1000)}
                                          </Moment> - <Moment format="hh:mm:ss a">
                                              {new Date(sub.created * 1000)}
                                            </Moment></small></div>
                                          {/* <div><small><span class="badge border border-primary text-primary" data-bs-toggle="tooltip" title="Last: 23 jun 2034 04:49pm, 23 jun 2034 05:12pm">Label Printed</span></small> <small><span class="badge border border-info text-info" data-bs-toggle="tooltip" title="Last: 23 jun 2034 04:49pm, 23 jun 2034 05:12pm">Invoice Printed</span></small> <small><span class="badge border border-secondary text-secondary"  data-bs-toggle="tooltip" title="Manifested ID #345678908">Manifested</span></small></div> */}
                                        </td>
                                        {/* <td>{sub.items[0].item_name.substring(0, 20) + '...'} {sub.items.length > 1 ? "+1 items" : ""}
                                        </td> */}
                                        <td>
                                          <div><span class="badge rounded-pill bg-warning">{sub.payment_mode}</span></div>
                                        </td>
                                        <td>
                                          {sub.receiver.map((item) => (
                                            <>
                                              {item.name}
                                              {/* <div><small>{item.address.substring(0,20)}</small></div> */}
                                              <div><small>{item.city} , {item.state} - {item.pincode}</small></div>

                                              <div><small>{item.mobile}</small></div></>

                                          ))}
                                        </td>
                                        <td>
                                          <small>{sub.service_provider}</small>
                                          <div><a href="#" class="text-primary" data-bs-toggle="offcanvas" data-bs-target="#Order_data">{sub.carrier_tracking_number}</a></div>
                                        </td>
                                        <td>
                                          {sub.status == 0 ? <span class="status under_process"><img src="assets/images/spinner.gif" class="img-fluid" /> Under Processing</span> : sub.status == 10 ? <span class="status rtrn"> <i class="bi bi-arrow-clockwise"></i> RTO</span> : sub.status == 1 ? <span class="status pickup_awit"> <i class="bi bi-clock"></i> Pickup Awaited</span> : sub.status == 2 ? <span class="status pickedup"> <i class="bi bi-building-fill-up"></i> Pickedup</span> : sub.status == 3 ? <span class="status in_transit"> <i class="bi bi-truck"></i> In Transit</span> : sub.status == 4 ? <span class="status out_f_deli"> <i class="bi bi-rocket-takeoff"></i> Out for Delivery</span> : sub.status == 5 ? <span class="status "> <i class="bi bi-check2-all"></i> Delivered</span> : sub.status == 6 ? <span class="status cancelled"> <i class="bi bi-x-square"></i> Cancelled</span> : sub.status == 7 ? <span class="status failed"> <i class="bi bi-x-octagon"></i> Failed</span> : sub.status == 8 ? <span class="status failed"> <i class="bi bi-x-octagon"></i> NDR</span> : sub.status == 15 ? <span class="status failed"> <i class="bi bi-x-octagon"></i> Booked</span> : sub.status == 16 ? <span class="status "> <i class="bi bi-check2-all"></i>RTO Delivered</span> : sub.status == 19 ? <span class="status "> <i class="bi bi-check2-all"></i>RTO In Transit</span>
                                            : sub.status == 17 ? <span class="status failed"> <i class="bi bi-x-octagon"></i>Pickup Failed</span> : sub.status == 9 ? <>  <span class="status pickup_sechdls"> <i class="bi bi-calendar"></i> Pickup Scheduled</span><br /><br />
                                              {sub.pickup_date != undefined && sub.pickup_date != "" ? <small>on {sub.pickup_date != undefined ? sub.pickup_date : ""} at {sub.pickup_time != undefined ? sub.pickup_time : ""}</small> : ""} </> : <span class="badge rounded-pill bg-danger fw-400">Not Available</span>}
                                        </td>
                                        <td>
                                          <div class="text-success">{sub.total_ndr_attempt} Attempt(s)</div>
                                          <small><a onClick={(e) => sethistory({ ndr_history: sub.ndr_array ? sub.ndr_array : [], awb: sub.carrier_tracking_number })} style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target="#NDR_Modal" data-bs-backdrop="false" class="text-info">(Show History)</a></small>
                                        </td>
                                        <td>{sub.ndr_action_on ? <><Moment format="YYYY-MM-DD">
                                          {new Date(sub.ndr_action_on * 1000)}
                                        </Moment>
                                          <br />
                                          <Moment format="hh:mm:ss">
                                            {new Date(sub.ndr_action_on * 1000)}
                                          </Moment> </> : ""}</td>
                                        <td>

                                          <div class="text-success">{shipmentstate.status == 0 ?
                                            <div class="btn-group">
                                              {/* {sub.carrier_id=="1343170006" ||
                            sub.carrier_id == "1343170996"? */}
                                              <a type="button" class="btn btn-primary btn-sm" onClick={(e) => openModal(sub)} >Take Action</a>
                                              {/* :""} */}
                                              {/* <div class="btn-group">
                          <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"></button>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#">Re-Attempt</a>
                            <a class="dropdown-item" href="#">Update Address</a>
                            <a class="dropdown-item" href="#">Update Phone</a>
                            <a class="dropdown-item text-danger" href="#">Return</a>
                          </div>
                        </div> */}
                                            </div> : sub.ndr_action_required != 0 ? sub.ndr_array ? sub.ndr_array[0].action : "" : ""}</div>
                                          {/* <small>Dear team Pls call on this no. and arrange delivery tomorrow</small> */}
                                        </td>
                                        {sub.jp_array && sub.jp_array.length > 0 ? <td>{sub.jp_read_unread == 0 ? <div className="position-relative d-inline-block">
                                          <button
                                            onClick={() => set_update(sub)}
                                            className="btn btn-primary"
                                            style={{ cursor: "pointer", paddingRight: '24px', position: 'relative' }}
                                          >
                                            View
                                          </button>

                                          {/* Show the exclamation only if needed */}
                                          {sub.jp_read_unread === 0 && (
                                            <span
                                              className="position-absolute"
                                              style={{
                                                top: '-14px',
                                                right: '-11px',
                                                zIndex: 10, // Make sure it stays on top
                                                fontSize: '20px',
                                                color: 'red',
                                              }}
                                            >
                                              <i className="bi bi-exclamation-circle-fill"></i>
                                            </span>
                                          )}
                                        </div> : sub.jp_read_unread && sub.jp_read_unread == 1 ? <a onClick={() => set_update(sub)} style={{ cursor: "pointer" }} class="btn btn-secondary">View</a> : ""}</td> : ""}
                                      </tr>
                                    ))}


                                    <Modal show={viewModal.show} onHide={() => closemodaljp()} size="lg">
                                      <Modal.Header closeButton>
                                        <Modal.Title>JP Actions</Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        {viewModal.sub.jp_array ?
                                          viewModal.sub.jp_array.map((item) => (
                                            <section className="chatting_lists">
                                              {item.replied_by == "Admin" ?
                                                <div className="chat_list left_hand">
                                                  <img
                                                    src={`https://avatar.iran.liara.run/username?username=${item.replied_name}`}
                                                    className="img-fluid chat_list_img"
                                                    alt={`${item.replied_name}`}
                                                  />
                                                  <div>
                                                    <p>
                                                      {item.reply ? item.reply : ""}
                                                    </p>
                                                    {/* <strong>- Michel Wilson</strong> */}
                                                    <small>
                                                      <Moment format="MMM DD YYYY hh:mm">
                                                        {item.timestamp}
                                                      </Moment>
                                                    </small>
                                                    <h6>Attachments</h6>
                                                    {item.mp3_file && (
                                                      Array.isArray(item.mp3_file) ? (
                                                        item.mp3_file.length > 0 &&
                                                        item.mp3_file.map((file, idx) => {
                                                          const url = file.startsWith("https://cdn.shiprath.com/customer_assets/")
                                                            ? file
                                                            : `https://cdn.shiprath.com/customer_assets/${file}`;
                                                          return (
                                                            <audio key={idx} controls className="me-2 mb-2 d-block">
                                                              <source src={url} type="audio/mpeg" />
                                                            </audio>
                                                          );
                                                        })
                                                      ) : (
                                                        typeof item.mp3_file === "string" && item.mp3_file.trim() !== "" && (
                                                          <audio controls className="me-2 mb-2 d-block">
                                                            <source
                                                              src={
                                                                item.mp3_file.startsWith("https://cdn.shiprath.com/customer_assets/")
                                                                  ? item.mp3_file
                                                                  : `https://cdn.shiprath.com/customer_assets/${item.mp3_file}`
                                                              }
                                                              type="audio/mpeg"
                                                            />
                                                          </audio>
                                                        )
                                                      )
                                                    )}
                                                    <br />
                                                    <br />
                                                    {item.image_file && item.image_file != null ?
                                                      <img className='' height="100px" src={item.image_file}></img>
                                                      : ""}
                                                  </div>
                                                </div>
                                                :

                                                <div className="chat_list right_hand">
                                                  <img
                                                    src={`https://avatar.iran.liara.run/username?username=${item.replied_name}`}
                                                    className="img-fluid chat_list_img"
                                                    alt={`${item.replied_name}`}
                                                  />
                                                  <div>
                                                    <p>
                                                      {item.reply ? item.reply : ""}
                                                    </p>
                                                    <small>
                                                      <Moment format="MMM DD YYYY hh:mm">
                                                        {item.timestamp}
                                                      </Moment>
                                                    </small>

                                                  </div>
                                                </div>
                                              }
                                            </section>
                                          )) : ""}
                                            <div class="card p-2 mb-2">
              <div className='row'>
                {viewModal.sub.sender ?
                  <div class="col-12 col-md">
                    <h6>Ship From:</h6>
                    <small class="text-muted">Sender Name:</small>
                    <p>{viewModal.sub.sender[0].name}</p>
                    <small class="text-muted">Sender Address:</small>
                    <p>{viewModal.sub.sender[0].address}, {viewModal.sub.sender[0].city}, {viewModal.sub.sender[0].state} {viewModal.sub.sender[0].pincode}</p>
                    <small class="text-muted">Sender Email:</small>
                    <p>{viewModal.sub.sender[0].email}</p>
                    <small class="text-muted">Sender Mobile:</small>
                    <p>
                      {viewModal.sub.sender[0].mobile}
                    </p>
                  </div>
                  : ""}
                {viewModal.sub.receiver ?
                  <div class="col-12 col-md">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6>Ship To:</h6>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => setShowEditConsignee(!showEditConsignee)}
                      >
                        {showEditConsignee ? 'Cancel' : 'Edit'}
                      </button>
                    </div>
                    {showEditConsignee ? (
                      <div className="edit-consignee-form mb-3">
                        <div className="mb-2">
                          <label className="form-label">Select Field to Edit:</label>
                          <select
                            className="form-select mb-3"
                            value={selectedConsigneeField}
                            onChange={(e) => setSelectedConsigneeField(e.target.value)}
                          >
                            <option value="">Select field</option>
                            <option value="name">Name</option>
                            <option value="address">Address</option>
                            <option value="mobile">Mobile</option>
                            <option value="payment_mode">Payment Mode</option>
                          </select>
                        </div>

                        {selectedConsigneeField === 'name' && (
                          <div className="mb-2">
                            <label className="form-label">Receiver Name:</label>
                            <input
                              type="text"
                              className="form-control"
                              value={editedConsignee.name}
                              onChange={(e) => setEditedConsignee({ ...editedConsignee, name: e.target.value })}
                            />
                          </div>
                        )}

                        {selectedConsigneeField === 'address' && (
                          <div className="mb-2">
                            <label className="form-label">Receiver Address:</label>
                            <textarea
                              className="form-control"
                              value={editedConsignee.address}
                              onChange={(e) => setEditedConsignee({ ...editedConsignee, address: e.target.value })}
                            />
                          </div>
                        )}

                        {selectedConsigneeField === 'mobile' && (
                          <div className="mb-2">
                            <label className="form-label">Receiver Mobile:</label>
                            <input
                              type="text"
                              className="form-control"
                              value={editedConsignee.mobile}
                              onChange={(e) => setEditedConsignee({ ...editedConsignee, mobile: e.target.value })}
                            />
                          </div>
                        )}
                        
                        {selectedConsigneeField === 'payment_mode' && (
  <div className="mb-2">
    <label className="form-label">Payment Mode:</label>
    
    {/* If payment_mode is prepaid, show COD as locked */}
    {editedConsignee.payment_mode === 'prepaid' && (
      <select
        className="form-select"
        value="cod"
        disabled
      >
        <option value="cod">COD</option>
      </select>
    )}
    
    {/* If payment_mode is cod, show Prepaid as locked */}
    {editedConsignee.payment_mode === 'cod' && (
      <select
        className="form-select"
        value="prepaid"
        disabled
      >
        <option value="prepaid">Prepaid</option>
      </select>
    )}

    {/* Show COD amount field ONLY if payment_mode is prepaid (which shows COD as locked) */}
    {editedConsignee.payment_mode === 'prepaid' && (
      <div className="mt-2">
        <label className="form-label">COD Amount:</label>
        <input
          type="number"
          className="form-control"
          value={editedConsignee.cod_amount || ''}
          onChange={(e) =>
            setEditedConsignee({ ...editedConsignee, cod_amount: e.target.value })
          }
          placeholder="Enter COD amount"
        />
      </div>
    )}
  </div>
)}

                        {selectedConsigneeField && (
                          <button
                            className="btn btn-sm btn-success"
                            onClick={handleConsigneeUpdate}
                            disabled={
                              isUpdatingConsignee ||
                              !editedConsignee[selectedConsigneeField] ||
                              (selectedConsigneeField === 'payment_mode' &&
                                editedConsignee.payment_mode === 'prepaid' && // UI shows COD as locked
                                !editedConsignee.cod_amount)
                            }
                          >
                            {isUpdatingConsignee ? 'Updating...' : 'Update'}
                          </button>
                        )}
                      </div>
                    ) : (
                      <>
                        <small class="text-muted">Receiver Name:</small>
                        <p>{viewModal.sub.receiver[0].name}</p>
                        <small class="text-muted">Receiver Address:</small>
                        <p>{viewModal.sub.receiver[0].address}, {viewModal.sub.receiver[0].city}, {viewModal.sub.receiver[0].state} {viewModal.sub.receiver[0].pincode}</p>
                        <small class="text-muted">Receiver Email:</small>
                        <p>{viewModal.sub.receiver[0].email}</p>
                        <small class="text-muted">Receiver Mobile:</small>
                        <p>
                          {viewModal.sub.receiver[0].mobile}
                        </p>
                      </>
                    )}
                  </div>
                  : ""}
              </div>
            </div>
                                        <div className="row" id="reaise_disp">
                                          <div className="col-12 col-md-12 mb-3">
                                            <Form.Label>Enter Details:</Form.Label>
                                            <Form.Control
                                              as="textarea"
                                              rows={5}
                                              value={replyText}
                                              onChange={(e) => setReplyText(e.target.value)}
                                              placeholder="Enter details"
                                            />
                                          </div>
                                          {/* Reply button */}
                                          <div className="col-12 col-md-12 mb-3">
                                            <button className="btn btn-primary" onClick={handleReplySubmit}>
                                              Reply
                                            </button>
                                          </div>
                                        </div>
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <button className="btn btn-secondary" onClick={() => closemodaljp()}>
                                          Close
                                        </button>
                                      </Modal.Footer>
                                    </Modal>
                                    <div class="modal" id="NDR_Modal" data-bs-backdrop="false">
                                      <div class="modal-dialog modal-xl">
                                        <div class="modal-content">
                                          <div class="modal-header">
                                            <h4 class="modal-title">NDR History: AWB #{history.awb}</h4>
                                            <button type="button" onClick={(e) => sethistory({ ndr_history: [], awb: "" })} class="btn-close" data-bs-dismiss="modal"></button>
                                          </div>
                                          <div class="modal-body">
                                            <div class="table-responsive">
                                              <table class="table table-bordered table-hover table-sm">
                                                <thead class="bg-table">
                                                  <tr>
                                                    <th>Date</th>
                                                    <th>Action</th>
                                                    <th>Updated Details (If Any)</th>
                                                    <th>Remarks</th>
                                                    <th>NDR Count #</th>
                                                    <th>By</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {history.ndr_history.length > 0 ?
                                                    history.ndr_history.map((his) => (
                                                      <tr>
                                                        <td>{his.date}</td>
                                                        <td>{his.action}</td>
                                                        <td>{his.updated_details}</td>
                                                        <td>{his.remarks}</td>
                                                        <td class="text-center">{his.ndr_count}</td>
                                                        <td>{his.by}</td>
                                                      </tr>
                                                    )) : ""}

                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>


                                  </tbody>
                                </table>
                              </div>
                            </div>
                          }
                          {openOffdetailcanvas && (
                            <section class="order_data">
                              <div class="offcanvas offcanvas-end show" id="Shipment_data">
                                <div class="offcanvas-header shadow-sm">
                                  <h4 class="offcanvas-title">Shipment #{bookorder.shipment_id}</h4>
                                  <div class="shipm_tablew">
                                    {bookorder.status == 0 ? <span class="status under_process"><img src="assets/images/spinner.gif" class="img-fluid" /> Under Processing</span> : bookorder.status == 10 ? <span class="status rtrn"> <i class="bi bi-arrow-clockwise"></i> RTO</span> : bookorder.status == 19 ? <span class="status rtrn"> <i class="bi bi-arrow-clockwise"></i> RTO In Transit</span> : bookorder.status == 16 ? <span class="status rtrn"> <i class="bi bi-arrow-clockwise"></i> RTO Delivered</span> : bookorder.status == 1 ? <span class="status pickup_awit"> <i class="bi bi-clock"></i> Pickup Awaited</span> : bookorder.status == 2 ? <span class="status pickedup"> <i class="bi bi-building-fill-up"></i> Pickedup</span> : bookorder.status == 3 ? <span class="status in_transit"> <i class="bi bi-truck"></i> In Transit</span> : bookorder.status == 4 ? <span class="status out_f_deli"> <i class="bi bi-rocket-takeoff"></i> Out for Delivery</span> : bookorder.status == 5 ? <span class="status delivered"> <i class="bi bi-check2-all"></i> Delivered</span> : bookorder.status == 6 ? <span class="status cancelled"> <i class="bi bi-x-square"></i> Cancelled</span> : bookorder.status == 7 ? <span class="status failed"> <i class="bi bi-x-octagon"></i> Failed</span> : bookorder.status == 8 ? <span class="status failed"> <i class="bi bi-x-octagon"></i> NDR</span> : bookorder.status == 15 ? <span class="status failed"> <i class="bi bi-x-octagon"></i> Booked</span> : bookorder.status == 16 ? <span class="status delivered"> <i class="bi bi-check2-all"></i>RTO Delivered</span> : bookorder.status == 17 ? <span class="status failed"> <i class="bi bi-x-octagon"></i>Pickup Failed</span> : bookorder.status == 9 ? <>  <span class="status pickup_sechdls"> <i class="bi bi-calendar"></i> Pickup Scheduled</span><br /><br />
                                      {bookorder.pickup_date != undefined && bookorder.pickup_date != "" ? <small>on {bookorder.pickup_date != undefined ? bookorder.pickup_date : ""} at {bookorder.pickup_time != undefined ? bookorder.pickup_time : ""}</small> : ""} </> : <span class="badge rounded-pill bg-danger fw-400">Not Available</span>}
                                  </div>
                                  <div class="dropdown text-end">
                                    <button type="button" class="btn btn-outline-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
                                      Actions
                                    </button>
                                    <ul class="dropdown-menu">
                                      {bookorder.carrier_tracking_number ?


                                        <li>
                                          <a href={`/create_ticket?order_number=${bookorder.carrier_tracking_number}`} class="dropdown-item"> Raise Ticket</a>
                                        </li>
                                        : ""}
                                    </ul>
                                  </div>
                                  <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" onClick={(e) => closeOffdetailcanvasHandler(e)}></button>
                                </div>
                                {/* {failedstate.failed != "" ?
                                  <div class="alert alert-danger text-center" role="alert">
                                    Shipment Failed Due to "{failedstate.failed}"
                                  </div> : ""} */}
                                <div class="offcanvas-body">
                                  <section>



                                    <div class="">
                                      <div class="row mt-3 order_box_cont">
                                        <div class="col-12 col-md-8 ">




                                          <div class="card border-0 mb-3">
                                            <div class="card-body">
                                              <div class="d-flex ">
                                                <div class="border-end pe-3">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="truck" class="lucide lucide-truck"><path d="M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11"></path><path d="M14 9h4l4 4v4c0 .6-.4 1-1 1h-2"></path><circle cx="7" cy="18" r="2"></circle><path d="M15 18H9"></path><circle cx="17" cy="18" r="2"></circle></svg>
                                                </div>
                                                <div class="ps-3 ">
                                                  <h6>Shipping Details</h6>
                                                </div>
                                              </div>
                                              <hr />
                                              <div class="row">
                                                <div class="col-12 col-md-4 mb-2 shipping_carrier_im">
                                                  <img src={`https://cdn.shiprath.com/images/${bookorder.carrier_image}`} alt="" class="img-fluid" title="Fedex Inc." />
                                                </div>
                                                <div class="col-6 col-md-4 mb-2">
                                                  <small class="text-muted">Shipment No.</small>
                                                  <p><strong><a href="">{bookorder.shipment_id}</a></strong></p>
                                                </div>
                                                <div class="col-6 col-md-4 mb-2">
                                                  <small class="text-muted">Order on</small>
                                                  <p><a href="">{bookorder.shipment_created_date}</a></p>
                                                </div>
                                                <div class="col-6 col-md-4 mb-2">
                                                  <small class="text-muted">Shipping Courier</small>
                                                  <p>{bookorder.service_provider ? bookorder.service_provider : bookorder.carrier_name}</p>
                                                </div>
                                                {bookorder.carrier_type == "B2B" ?
                                                  <div class="col-6 col-md-4 mb-2">
                                                    <small class="text-muted">Shipping Courier LR No.</small>
                                                    <p><a href="">{bookorder.lrnum ? bookorder.lrnum : ""}</a></p>
                                                  </div>
                                                  :
                                                  <div class="col-6 col-md-4 mb-2">
                                                    <small class="text-muted">Shipping Courier AWB No.</small>
                                                    <p><a href="">{bookorder.carrier_tracking_number ? bookorder.carrier_tracking_number : ""}</a></p>
                                                  </div>
                                                }
                                                <div class="col-6 col-md-4 mb-2">
                                                  <small class="text-muted">Shipping Courier Service</small>
                                                  <p>{bookorder.service_provider}</p>
                                                </div>
                                                <div class="col-6 col-md-4 mb-2">
                                                  <small class="text-muted">Order Type</small>
                                                  <p>{bookorder.mode}</p>
                                                </div>
                                                <div class="col-6 col-md-4 mb-2">
                                                  <small class="text-muted">Shipment Type</small>
                                                  <p>Forward</p>
                                                </div>
                                                <div class="col-6 col-md-4 mb-2">
                                                  <small class="text-muted">Zone</small>
                                                  <p>{bookorder.zone_name}</p>
                                                </div>
                                                <div class="col-6 col-md-4 mb-2">
                                                  <small class="text-muted">Courier Rule Applied</small>
                                                  <p>N/A</p>
                                                </div>
                                                <div class="col-6 col-md-4 mb-2">
                                                  <small class="text-muted">Payment Mode</small>
                                                  <p>{bookorder.payment_mode.toUpperCase()}</p>
                                                </div>
                                                {bookorder.payment_mode == "prepaid" ? "" :
                                                  <div class="col-6 col-md-4 mb-2">
                                                    <small class="text-muted">Cod Value</small>
                                                    <p>{bookorder.cod_amount}</p>
                                                  </div>
                                                }
                                                {bookorder.carrier_type == "B2B" ?
                                                  <>
                                                    <div class="col-6 col-md-4 mb-2"><a class="btn btn-primary" onClick={() => downloadDocket(bookorder)} >Download Docket</a></div>
                                                    {bookorder.status == 5 ?
                                                      <div class="col-6 col-md-4 mb-2"><a class="btn btn-primary" onClick={() => downloadPOD(bookorder)} >Download POD</a></div>
                                                      : ""}
                                                  </>
                                                  : ""}
                                                <div class="col-12 col-md-4 mb-2 desk_display_none">
                                                  <div class="d-grid">
                                                    <a href="#track_shipment" class="btn btn-outline-secondary btn-block">Track Shipment</a>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="card border-0  mb-3">
                                            <div class="card-body">
                                              <div class="d-flex ">
                                                <div class="border-end pe-3">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package-open" class="lucide lucide-package-open"><path d="M20.91 8.84 8.56 2.23a1.93 1.93 0 0 0-1.81 0L3.1 4.13a2.12 2.12 0 0 0-.05 3.69l12.22 6.93a2 2 0 0 0 1.94 0L21 12.51a2.12 2.12 0 0 0-.09-3.67Z"></path><path d="m3.09 8.84 12.35-6.61a1.93 1.93 0 0 1 1.81 0l3.65 1.9a2.12 2.12 0 0 1 .1 3.69L8.73 14.75a2 2 0 0 1-1.94 0L3 12.51a2.12 2.12 0 0 1 .09-3.67Z"></path><line x1="12" x2="12" y1="22" y2="13"></line><path d="M20 13.5v3.37a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13.5"></path></svg>
                                                </div>
                                                <div class="ps-3 ">
                                                  <h6>Package Details</h6>
                                                </div>
                                              </div>
                                              <hr />
                                              <div class="row">
                                                <div class="col-12 col-md-4 mb-2">
                                                  <small class="text-muted">Initial Applicable Weight (in Kg)</small>
                                                  <p>{bookorder.total_weight.toFixed(2)}KG</p>
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                  <small class="text-muted">Dead Weight (in Kg)</small>
                                                  <p>{bookorder.dead_weight.toFixed(2)}KG</p>
                                                </div>
                                                {/* <div class="col-12 col-md-4 mb-2">
                                        <small class="text-muted">Volumetric Weight (in kg)</small>
                                        <p>{bookorder.volumetric_weight}KG</p>
                                      </div> */}
                                                <div class="col-12 col-md-4 mb-2">
                                                  <small class="text-muted">Dimensions (in cm)</small>
                                                  <p>{bookorder.height} x {bookorder.width} x {bookorder.length}</p>
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                  <small class="text-muted">Number of Boxes</small>
                                                  <p>1</p>
                                                </div>
                                                {bookorder.b2b_discrepancy_weight ?
                                                  <div class="col-12 col-md-4 mb-2">
                                                    <strong class="">Chargeable Weight </strong>
                                                    <p>{Number(bookorder.b2b_discrepancy_weight + bookorder.total_weight).toFixed(2)} KG</p>
                                                  </div>
                                                  : ""}
                                              </div>
                                            </div>
                                          </div>
                                          {bookorder.carrier_type == "B2B" ?
                                            <div class="card border-0 mb-3">
                                              <div class="card-body">
                                                <div class="d-flex ">
                                                  <div class="border-end pe-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="shopping-basket" class="lucide lucide-shopping-basket"><path d="m15 11-1 9"></path><path d="m19 11-4-7"></path><path d="M2 11h20"></path><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path><path d="M4.5 15.5h15"></path><path d="m5 11 4-7"></path><path d="m9 11 1 9"></path></svg>
                                                  </div>
                                                  <div class="ps-3 ">
                                                    <h6>VAS Charges</h6>
                                                  </div>
                                                </div>
                                                <hr />
                                                <div class="table-responsive ">
                                                  <table class="table table-light">
                                                    <thead>
                                                      <tr>
                                                        <th>Charge Type</th>
                                                        <th>Amount</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {bookorder.vasChargesHistory ?
                                                        bookorder.vasChargesHistory.map((sub) => (
                                                          <tr>

                                                            <td>{sub.chargeType}</td>
                                                            <td>{sub.amount}</td>
                                                          </tr>
                                                        )) : ""}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div> : ""}


                                          <div class="card border-0 mb-3">
                                            <div class="card-body">
                                              <div class="d-flex ">
                                                <div class="border-end pe-3">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package" class="lucide lucide-package"><path d="m7.5 4.27 9 5.15"></path><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path><path d="m3.3 7 8.7 5 8.7-5"></path><path d="M12 22V12"></path></svg>
                                                </div>
                                                <div class="ps-3 ">
                                                  <h6>Shipment Details</h6>
                                                </div>
                                              </div>
                                              <hr />
                                              <div class="row">
                                                <div class="col-12 col-md">
                                                  <h6>Ship From:</h6>
                                                  <small class="text-muted">Sender Name:</small>
                                                  <p>{bookorder.sender[0].name}</p>
                                                  <small class="text-muted">Sender Address:</small>
                                                  <p>{bookorder.sender[0].address},{bookorder.sender[0].city}, {bookorder.sender[0].state} {bookorder.sender[0].pincode}</p>
                                                  <small class="text-muted">Sender Email:</small>
                                                  <p>{bookorder.sender[0].email}</p>
                                                  <small class="text-muted">Sender Mobile:</small>
                                                  <p>{bookorder.sender[0].mobile}</p>
                                                </div>
                                                <div class="col-12 col-md">
                                                  <h6>Ship To:</h6>
                                                  <small class="text-muted">Receiver Name:</small>
                                                  <p>{bookorder.receiver[0].name}</p>
                                                  <small class="text-muted">Receiver Address:</small>
                                                  <p>{bookorder.receiver[0].address},{bookorder.receiver[0].city}, {bookorder.receiver[0].state} {bookorder.receiver[0].pincode}</p>
                                                  <small class="text-muted">Receiver Email:</small>
                                                  <p>{bookorder.receiver[0].email}</p>
                                                  <small class="text-muted">Receiver Mobile:</small>
                                                  <p>{bookorder.receiver[0].mobile}</p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>


                                          <div class="card border-0  mb-3">
                                            <div class="card-body">
                                              <div class="d-flex ">
                                                <div class="border-end pe-3">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="dollar-sign" class="lucide lucide-dollar-sign"><line x1="12" x2="12" y1="2" y2="22"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                                                </div>
                                                <div class="ps-3 ">
                                                  <h6>Payment Details</h6>
                                                </div>
                                              </div>
                                              <hr />
                                              <div class="row">
                                                <div class="col-12 col-md-4 mb-2">
                                                  <small class="text-muted">Total Paid Amount</small>
                                                  <p>₹ {bookorder.total_amount}</p>
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                  <small class="text-muted">Payment Mode</small>
                                                  <p>Wallet</p>
                                                </div>
                                                {/* <div class="col-12 col-md-4 mb-2">
                                                    <small class="text-muted">Transaction ID</small>
                                                    <p><a href="">3456789876</a></p>
                                                </div> */}
                                              </div>
                                            </div>
                                          </div>
                                          {bookorder.carrier_type == "B2B" ?
                                            <div class="card border-0 mb-3">
                                              <div class="card-body">
                                                <div class="d-flex ">
                                                  <div class="border-end pe-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="shopping-basket" class="lucide lucide-shopping-basket"><path d="m15 11-1 9"></path><path d="m19 11-4-7"></path><path d="M2 11h20"></path><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path><path d="M4.5 15.5h15"></path><path d="m5 11 4-7"></path><path d="m9 11 1 9"></path></svg>
                                                  </div>
                                                  <div class="ps-3 ">
                                                    <h6>Boxes Details</h6>
                                                  </div>
                                                </div>
                                                <hr />
                                                <div class="table-responsive ">
                                                  <table class="table table-light">
                                                    <thead>
                                                      <tr>
                                                        <th>Length</th>
                                                        <th>Width</th>
                                                        <th>Height</th>
                                                        <th>Weight</th>
                                                        <th>Quantity</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {bookorder.boxes.map((sub) => (
                                                        <tr>

                                                          <td>{sub.box_length}</td>
                                                          <td>{sub.box_width}</td>
                                                          <td>{sub.box_height}</td>
                                                          <td>{sub.box_weight}</td>
                                                          <td>{sub.quantity}</td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div> : ""}

                                          {bookorder.carrier_type == "B2B" ?
                                            <div class="card border-0 mb-3">
                                              <div class="card-body">
                                                <div class="d-flex ">
                                                  <div class="border-end pe-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="shopping-basket" class="lucide lucide-shopping-basket"><path d="m15 11-1 9"></path><path d="m19 11-4-7"></path><path d="M2 11h20"></path><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path><path d="M4.5 15.5h15"></path><path d="m5 11 4-7"></path><path d="m9 11 1 9"></path></svg>
                                                  </div>
                                                  <div class="ps-3 ">
                                                    <h6>Invoices Details</h6>
                                                  </div>
                                                </div>
                                                <hr />
                                                <div class="table-responsive ">
                                                  <table class="table table-light">
                                                    <thead>
                                                      <tr>
                                                        <th>Invoice Number</th>
                                                        <th>Invoice Amount</th>
                                                        <th>Invoice EBN</th>
                                                        {/* <th>Total</th> */}
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {bookorder.invoices.map((sub) => (
                                                        <tr>

                                                          <td>{sub.invoice_number}</td>
                                                          <td>{sub.invoice_amount}</td>
                                                          <td>{sub.invoice_ebn}</td>
                                                          {/* <td> {bookorder.invoices.reduce((total, sub) => total + parseFloat(sub.invoice_amount), 0).toFixed(2)}</td> */}
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div> : ""}




                                        </div>
                                        <div class="col-12 col-md-4">
                                          {/* <section class="bg-white p-3 mb-3">
                        <p>
                            Jaipur <i class="bi bi-arrow-right"></i> Delhi
                            <span class="text-end"><small class="text-muted">Location last updated on 3 May 2022 09:38</small></span>
                        </p>
        
                        
                        <p>Delivery ETA - <span class="text-muted">03-02-2022 @ 23:29</span></p>
                    </section> */}
                                          <div class="card border-0 shadow-sm tracking_xb">
                                            <div class="card-body">
                                              <div class="d-flex ">
                                                <div class="border-end pe-3">
                                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package-search" class="lucide lucide-package-search"><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"></path><path d="m7.5 4.27 9 5.15"></path><polyline points="3.29 7 12 12 20.71 7"></polyline><line x1="12" x2="12" y1="22" y2="12"></line><circle cx="18.5" cy="15.5" r="2.5"></circle><path d="M20.27 17.27 22 19"></path></svg>
                                                </div>
                                                <div class="ps-3 ">
                                                  <h6>Tracking Info</h6>
                                                </div>
                                              </div>
                                              <hr />
                                              {trackingstate.track != '' && stateship.shipmentDetail != '' ?
                                                <div class="progress-container  position-relative">
                                                  {trackingstate.isLoading == false ?
                                                    trackingstate.track.history.length > 0 ?
                                                      trackingstate.track.history.map((sub) => (
                                                        <div class="step-container">
                                                          <div class="step active">
                                                            <i class="bi bi-check-circle-fill"></i>
                                                          </div>
                                                          <div class="progress"></div>
                                                          <div class="step-info">
                                                            <h4>{sub.message} </h4>
                                                            <p>{sub.location}</p>
                                                            <p><Moment format="MMM DD YYYY hh:mm:ss a">
                                                              {(sub.time)}
                                                            </Moment></p>
                                                          </div>
                                                        </div>
                                                      )) : "No Data Available" : <ReactLoading type="bubbles" color="#0d6efd" style={{ position: 'absolute', right: '45%', height: '20px', width: '10%' }} />}

                                                </div> : "No Data Available"}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </section>
                                </div>
                              </div>
                              <div className='offcanvas-backdrop fade show'></div>
                            </section>
                          )}
                        </div>
                      </div>
                    </div>
                    <TablePagination
                      component="div"
                      rowsPerPageOptions={[200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                      count={otherStates.total_count}
                      page={otherStates.page}
                      onPageChange={handlePageChange}
                      rowsPerPage={otherStates.rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}

                    />
                  </div>
                </section>









              </div></div>
            <Footer /></div></div></div>

    </div>
  )
}

export default Ndr
